import { render } from "./GastosPendientesCompartidos.vue?vue&type=template&id=3562b563"
import script from "./GastosPendientesCompartidos.vue?vue&type=script&lang=js"
export * from "./GastosPendientesCompartidos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__